export default __webpack_public_path__ + "static/media/journal-icon.0875bfb0.svg";